export default {
  run(ed) {
    ed.DomComponents.clear();
    ed.CssComposer.clear();
  }
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/commands/view/CanvasClear.js